<div class="border-t border-primary-700">
    <div class="flex justify-between">
        <div class="self-start">
            <span class="text-error-700">
                * Fields Required for FCC Submission
            </span>
        </div>
        <div class="flex space-x-2">
            @if (showPreviousButton) {
                <button
                    class="primary-button"
                    type="button"
                    (click)="previous()"
                    mat-raised-button
                    color="primary"
                >
                    Previous
                </button>
            }

            @if (showNextButton) {
                <button
                    class="primary-button"
                    type="submit"
                    mat-raised-button
                    color="primary"
                    (click)="next()"
                >
                    Next
                </button>
            }
        </div>
    </div>
</div>
